module.exports = __webpack_public_path__ + "img/Menu-10.c708357c.png";